import type { ITpaContextMapping, ITpaSrcBuilder } from 'feature-tpa-commons'
import type { IPropsStore, IStructureAPI } from '@wix/thunderbolt-symbols'

type CreateWorkerArgs = {
	tpaContextMapping: ITpaContextMapping
	props: IPropsStore
	tpaSrcBuilder: ITpaSrcBuilder
	structureApi: IStructureAPI
	workerId: string
	appDefinitionId?: string
	appWorkerUrl: string
	appDefinitionName: string
}

type DestroyWorkerArgs = {
	tpaContextMapping: ITpaContextMapping
	props: IPropsStore
	structureApi: IStructureAPI
	workerId: string
}

const TPA_WORKER_PREFIX = 'tpaWorker_'

const tpaWorkerCompIdRegex = new RegExp(`^${TPA_WORKER_PREFIX}([0-9]+)$`)

export const isTpaWorker = (compId: string) => compId.includes(TPA_WORKER_PREFIX)

export const getWorkerApplicationId = (compId: string) => {
	return tpaWorkerCompIdRegex.exec(compId)?.[1]
}

export const getWorkerAppDefId = (compId: string) => {
	return compId.split(TPA_WORKER_PREFIX)?.[1]
}

export const getWorkerId = (appDefinitionId: string) => {
	return `${TPA_WORKER_PREFIX}${appDefinitionId}`
}

export const createWorker = ({
	tpaContextMapping,
	props,
	tpaSrcBuilder,
	structureApi,
	workerId,
	appDefinitionId,
	appWorkerUrl,
	appDefinitionName,
}: CreateWorkerArgs): void => {
	tpaContextMapping.registerTpasForContext({ contextId: 'masterPage', pageId: 'masterPage' }, [workerId])

	props.update({
		[workerId]: {
			title: appDefinitionName,
			src: tpaSrcBuilder.buildSrc(workerId, 'masterPage', {}, appWorkerUrl, {
				extraQueryParams: {
					endpointType: 'worker',
				},
				appDefinitionId,
			}),
		},
	})

	void structureApi.addComponentToDynamicStructure(workerId, {
		components: [],
		componentType: 'TPAWorker',
	})
}

export const destroyWorker = ({ structureApi, workerId, tpaContextMapping }: DestroyWorkerArgs): void => {
	structureApi.removeComponentFromDynamicStructure(workerId)
	tpaContextMapping.unregisterTpa(workerId)
}
